import { render, staticRenderFns } from "./IconActivity.vue?vue&type=template&id=25715bc3"
import script from "./IconActivity.vue?vue&type=script&lang=js"
export * from "./IconActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports